import { DialogActions as NovaBaseDialogActions } from '@fme-nova/components'
import { DialogActions as MuiBaseDialogActions, DialogActionsProps, styled } from '@mui/material'

import { createComponentWrapperWithRef } from '../../theme'
import { MsdkStyledComponent } from '../../utils'

const MuiDialogActions: MsdkStyledComponent<DialogActionsProps> = styled(MuiBaseDialogActions)`
  padding: 16px 24px;
  gap: 8px;
`

const NovaDialogActions: MsdkStyledComponent<DialogActionsProps> = styled(NovaBaseDialogActions)``

export const DialogActions = createComponentWrapperWithRef<DialogActionsProps>(
  {
    mui: MuiDialogActions,
    nova: NovaDialogActions,
  },
  'DialogActions',
)
